'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Search4 = function Search4(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 17.593 17.531' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('defs', null),
      _react2.default.createElement('path', { d: 'M.722 17.56l-.698-.698 4.412-4.413c-1.177-1.327-1.915-3.054-1.915-4.968a7.517 7.517 0 0 1 7.517-7.517 7.517 7.517 0 1 1 0 15.034c-1.881 0-3.579-.715-4.898-1.857L.722 17.56zm9.423-3.647a6.417 6.417 0 1 0 .002-12.834 6.417 6.417 0 0 0-.002 12.834z',
        className: 'cls-1' })
    )
  );
};
/*eslint-enable */

exports.default = Search4;
//# sourceMappingURL=Search4.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Search4.js